import PopUp from "Components/PopUp/PopUp";
import { Separator } from "Components/ui/separator";
import { Asterisk, Copy, CopyCheck, Eye, EyeOff } from "lucide-react";
import React, { useEffect, useState } from "react";
import MT5new from "../../../Assets/Images/mt5new.png";
import PC from "../../../Assets/Images/pc.svg";
import download from "../../../Assets/Images/download.svg";
import apple from "../../../Assets/Images/appleLogo.svg";
import android from "../../../Assets/Images/android.svg";
import { useDispatch, useSelector } from "react-redux";
import { getStageDetails } from "../../../Redux/ChallengeOverview/ChallengeOverviewAction";
import { useParams } from "react-router-dom";
import mt5Icon from "../../../Assets/Images/mt5icon.svg";
import { useAuth } from "@clerk/clerk-react";

function MT5Credentials({ open, setOpen }) {
  const params = useParams();
  const { id } = params;
  const dispatch = useDispatch();

  const [loginCopy, setLoginCopy] = useState(false);
  const [serverNameCopy, setServerNameCopy] = useState(false);
  const [investorPassCopy, setInvestorPassCopy] = useState(false);
  const [masterPassCopy, setMasterPassCopy] = useState(false);
  const [showPass, setShowPass] = useState();
  const { challengeStageInfoLoading, challengeCredentials } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const { getToken } = useAuth();

  useEffect(() => {
    if (!(Object.keys(challengeCredentials).length > 0) && id && open)
      dispatch(getStageDetails(getToken, id));
  }, [challengeCredentials, id, open]);

  useEffect(() => {
    if (!open) {
      setShowPass({});
    }
  }, [open]);
  return (
    <PopUp open={open} setOpen={setOpen} title="Credentials & Downloads">
      <div className="flex flex-col gap-4 w-full max-h-[80vh] overflow-y-auto hideScrollBar">
        <div className="flex flex-col gap-4 w-full">
          <div className="flex  gap-2 items-center justify-between sm:flex-row flex-col ">
            <span className="text-lg text-white-opacity font-G_Regular sm:w-[33%] w-full sm:text-left text-center ">
              Login ID
            </span>
            <div className="text-lg font-G_Bold sm:w-[33%] w-full text-center">
              {challengeCredentials?.login || "-"}
            </div>
            <div className="sm:w-[33%] w-full flex sm:justify-end justify-center">
              <div
                className="bg-primary-foreground py-2 px-5 text-primary rounded-full cursor-pointer text-xs flex items-center  gap-1"
                onClick={() => {
                  navigator.clipboard.writeText(challengeCredentials?.login);
                  setLoginCopy(true);

                  setTimeout(() => {
                    setLoginCopy(false);
                  }, 2000);
                }}
              >
                {loginCopy ? (
                  <CopyCheck size={"0.8rem"} color="var(--primary)" />
                ) : (
                  <Copy size={"0.8rem"} color="var(--primary)" />
                )}
                {!loginCopy ? "Copy" : "Copied"}
              </div>
            </div>
          </div>
          <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl" />

          <div className="flex  gap-2 items-center justify-between w-full sm:flex-row flex-col">
            <span className="text-lg text-white-opacity font-G_Regular sm:w-[33%] w-full sm:text-left text-center">
              Server Name
            </span>
            <div className="text-lg font-G_Bold sm:w-[33%] w-full text-center">
              FazoLiquidity-Server
            </div>
            <div className="sm:w-[33%] w-full flex sm:justify-end justify-center">
              <div
                className="bg-primary-foreground py-2 px-5 text-primary rounded-full cursor-pointer text-xs flex items-center  gap-1   w-fit"
                onClick={() => {
                  navigator.clipboard.writeText("FazoLiquidity-Server");
                  setServerNameCopy(true);

                  setTimeout(() => {
                    setServerNameCopy(false);
                  }, 2000);
                }}
              >
                {serverNameCopy ? (
                  <CopyCheck size={"0.8rem"} color="var(--primary)" />
                ) : (
                  <Copy size={"0.8rem"} color="var(--primary)" />
                )}
                {!serverNameCopy ? "Copy" : "Copied"}
              </div>
            </div>
          </div>
          <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl " />

          <div className="flex  gap-2 items-center justify-between sm:flex-row flex-col  ">
            <span className="text-lg text-white-opacity font-G_Regular sm:w-[33%] w-full sm:text-left text-center">
              Master Password
            </span>
            <div className="text-lg font-G_Bold sm:w-[33%] w-full justify-center flex items-center gap-2">
              <div className="flex items-center">
                {showPass?.master
                  ? challengeCredentials?.masterPass
                  : challengeCredentials?.masterPass
                      ?.split("")
                      .map((item, index) => <Asterisk size={"1rem"} />)}
              </div>
              {!showPass?.master ? (
                <EyeOff
                  size={"1rem"}
                  color="var(--white-opacity)"
                  className="cursor-pointer"
                  onClick={() =>
                    setShowPass({ ...showPass, master: !showPass?.master })
                  }
                />
              ) : (
                <Eye
                  size={"1rem"}
                  color="var(--white-opacity)"
                  className="cursor-pointer"
                  onClick={() =>
                    setShowPass({ ...showPass, master: !showPass?.master })
                  }
                />
              )}
            </div>
            <div className="w-[33%] flex sm:justify-end justify-center">
              <div
                className="bg-primary-foreground py-2 px-5 text-primary rounded-full cursor-pointer text-xs flex items-center  gap-1"
                onClick={() => {
                  navigator.clipboard.writeText(
                    challengeCredentials?.masterPass
                  );
                  setMasterPassCopy(true);
                  setTimeout(() => {
                    setMasterPassCopy(false);
                  }, 2000);
                }}
              >
                {masterPassCopy ? (
                  <CopyCheck size={"0.8rem"} color="var(--primary)" />
                ) : (
                  <Copy size={"0.8rem"} color="var(--primary)" />
                )}
                {!masterPassCopy ? "Copy" : "Copied"}
              </div>
            </div>
          </div>
          <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl" />
          <div className="flex  gap-2 items-center justify-between sm:flex-row flex-col">
            <span className="text-lg text-white-opacity font-G_Regular sm:w-[33%] w-full sm:text-left text-center">
              Investor Password
            </span>
            <div className="text-lg font-G_Bold sm:w-[33%] w-full justify-center flex items-center gap-2">
              <div className="flex items-center">
                {showPass?.investorPass
                  ? challengeCredentials?.investorPass
                  : challengeCredentials?.investorPass
                      ?.split("")
                      ?.map((item, index) => <Asterisk size={"1rem"} />)}
              </div>
              {!showPass?.investorPass ? (
                <EyeOff
                  size={"1rem"}
                  color="var(--white-opacity)"
                  className="cursor-pointer"
                  onClick={() =>
                    setShowPass({
                      ...showPass,
                      investorPass: !showPass?.investorPass,
                    })
                  }
                />
              ) : (
                <Eye
                  size={"1rem"}
                  color="var(--white-opacity)"
                  className="cursor-pointer"
                  onClick={() =>
                    setShowPass({
                      ...showPass,
                      investorPass: !showPass?.investorPass,
                    })
                  }
                />
              )}
            </div>
            <div className=" sm:w-[33%] w-full flex sm:justify-end justify-center">
              <div
                className="bg-primary-foreground py-2 px-5 text-primary rounded-full cursor-pointer text-xs flex items-center  gap-1"
                onClick={() => {
                  navigator.clipboard.writeText(
                    challengeCredentials?.investorPass
                  );
                  setInvestorPassCopy(true);
                  setTimeout(() => {
                    setInvestorPassCopy(false);
                  }, 2000);
                }}
              >
                {investorPassCopy ? (
                  <CopyCheck size={"0.8rem"} color="var(--primary)" />
                ) : (
                  <Copy size={"0.8rem"} color="var(--primary)" />
                )}
                {!investorPassCopy ? "Copy" : "Copied"}
              </div>
            </div>
          </div>
          <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl" />
        </div>
        <div className="flex flex-col gap-4 mt-5">
          <div className="flex items-center gap-4 mb-2">
            <div className="flex flex-col">
              <div className="text-base font-G_Bold">Download Platform 5</div>
              <div className="text-sm text-white-opacity">
                Get Platform 5 for your preferred device and start trading
                today.
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4 justify-between sm:flex-row flex-col">
            <div
              className="bg-primary-foreground py-3 px-5 text-white rounded-lg cursor-pointer flex flex-col  gap-4 sm:w-[30%] w-full sm:items-start items-center"
              onClick={() =>
                window.open(
                  "https://download.mql5.com/cdn/web/metaquotes.ltd/mt5/mt5setup.exe?utm_source=www.metatrader5.com&utm_campaign=download",
                  "_blank"
                )
              }
            >
              <div className="flex flex-row gap-2 item-center">
                <div className="bg-[#2c373d] w-10 aspect-square  rounded-full flex items-center justify-center">
                  <img src={mt5Icon} alt="mt5Icon" className="w-4" />
                </div>
                <img src={PC} alt="PC" className="w-10 h-auto" />
              </div>
              <div className="text-base">Download on Windows</div>

              <div className="flex items-center gap-2 text-primary font-G_Bold text-sm ">
                <img src={download} alt="download" className="w-4 h-auto" />
                Download
              </div>
            </div>
            <div
              className="bg-primary-foreground py-3 px-5 text-white rounded-lg cursor-pointer flex flex-col  gap-4 sm:w-[30%] w-full sm:items-start items-center"
              onClick={() =>
                window.open(
                  "https://download.mql5.com/cdn/web/metaquotes.ltd/mt5/MetaTrader5.pkg.zip?utm_source=www.metatrader5.com&utm_campaign=download.mt5.macos",
                  "_blank"
                )
              }
            >
              <div className="flex flex-row gap-2 item-center">
                <div className="bg-[#2c373d] w-10 aspect-square  rounded-full flex items-center justify-center">
                  <img src={mt5Icon} alt="mt5Icon" className="w-4" />
                </div>
                <img src={apple} alt="PC" className="w-10 h-auto" />
              </div>
              <div className="text-base">Download on macOS</div>

              <div className="flex items-center gap-2 text-primary font-G_Bold text-sm ">
                <img src={download} alt="download" className="w-4 h-auto" />
                Download
              </div>
            </div>{" "}
            <div
              className="bg-primary-foreground py-3 px-5 text-white rounded-lg cursor-pointer flex flex-col  gap-4 sm:w-[30%] w-full sm:items-start items-center"
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en&referrer=ref_id%3D5190009270727833975%26utm_source%3Dwww.metatrader5.com%26utm_campaign%3Dinstall.metaquotes&pli=1",
                  "_blank"
                )
              }
            >
              <div className="flex flex-row gap-2 item-center">
                <div className="bg-[#2c373d] w-10 aspect-square  rounded-full flex items-center justify-center">
                  <img src={mt5Icon} alt="mt5Icon" className="w-4" />
                </div>
                <img src={android} alt="PC" className="w-10 h-auto" />
              </div>
              <div className="text-base">Download on Android</div>

              <div className="flex items-center gap-2 text-primary font-G_Bold text-sm ">
                <img src={download} alt="download" className="w-4 h-auto" />
                Download
              </div>
            </div>
          </div>
        </div>
      </div>
    </PopUp>
  );
}

export default MT5Credentials;
